import './SizeTable.scss'

export default function SizeTable({ children }) {
    return <table className="SizeTable">
        {children}
    </table>
}


export function SizeTableHeader({ children }) {
    return <div className="SizeTable__header">
        {children}
    </div>
}


export function SizeTableLabel({ children, bgcolor, color }) {
    return <div className="SizeTable__label" style={{ backgroundColor: bgcolor, color: color }}>
        {children}
    </div>

}